export default __webpack_public_path__ + "static/media/611.6e5390dd.jpg";